/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(private http: HttpClient) {
  }

  //in case we need it
  public getCookie(name: string) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length == 2) {
      return parts.pop().split(";").shift();
    }
  }

  public isAuthenticated(): Observable<boolean | null> {
    var subject = new Subject<boolean | null>();
    let options = {
      headers: new HttpHeaders(
        {
          'X-Requested-With': 'XMLHttpRequest',
          'X-QSMAuthHeader': 'AuthHeaderSecret'
        }
      )
    };
    try {
      this.http.get<boolean>('api/utilities/IsAuthorized', options)
        .subscribe(
          res => {
            this.setSubject(subject, res, "result");
          },
          res => {
            this.setSubject(subject, null, "error");
          },
          () => {
            this.setSubject(subject, null, "complete");
          }
        );
    }
    catch {
      this.setSubject(subject, null, "catch");
    }
    return subject.asObservable();
  }

  private setSubject(subject: Subject<boolean | null>, val: boolean | null, tag: string): boolean {
    //console.log("set Subject: isStopped:", subject.isStopped, " tag:", tag);
    if (!(subject.isStopped)) {
      subject.next(val);
      subject.complete();
    }
    return subject.isStopped;
  }

}
